import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DeleteUserComponent } from './delete-user/delete-user.component';
import { DeleteInstructionComponent } from './delete-instruction/delete-instruction.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [LoginComponent, DeleteUserComponent, DeleteInstructionComponent],
  exports: [LoginComponent],
  bootstrap: []
})
export class AuthModule { }
